// import React, { useState } from 'react'
// import Head from "./Head"
// import "./header.css"
// import {Link} from "react-router-dom"

// const Header = () => {
//   const[click,setClick]= useState(false)
//   return (
//     <>
//       <Head/>
//       <header>
//         <nav className= 'flexSB'>
//         <ul className={click ? "mobile-nav": 'flexSB'} onClick={()=>setClick(false)}>
//           <li>
//           <Link to="/">Home</Link>
//           </li>
//           <li>
//           <Link to="/Gallery">Gallery</Link>
//           </li>
//           <li>
//           <Link to="/Courses">All Courses</Link>
//           </li>
//           <li>
//           <Link to="/Contact">Contact</Link>
//           </li>
//           <li> <Link to ="/Parents">Parent's</Link>
//           </li>
//           <li>
//           <Link to="/about ">About</Link>
//           </li>
//           <li> <Link to="/locate us">Locate Us</Link>
//           </li>
//           <li> 
//           <Link to="/Admission">Admission</Link>
//           </li>
//         </ul>
//         <div className ='start'>
//         <Link to="/principal-desk" className="button">Principal's Desk</Link>
//         </div>

//          <button className='toggle' onClick={()=> setClick(!click)}>
//          {click ? <i className ='fa fa-times'></i>: <i className='fa fa-bars'></i>}
//          </button>
//         </nav>



//       </header>
//     </>
//   )
// }

// export default Header


// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom"; // Import useLocation
// import Head from "./Head";
// import "./header.css";

// const Header = () => {
//   const [click, setClick] = useState(false);
//   const location = useLocation(); // Get the current path

//   return (
//     <>
//       <Head />
//       <header>
//         <nav className="flexSB">
//           <ul
//             className={click ? "mobile-nav" : "flexSB"}
//             onClick={() => setClick(false)}
//           >
//             <li>
//               <Link to="/" className={location.pathname === "/" ? "active" : ""}>
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/Gallery"
//                 className={location.pathname === "/Gallery" ? "active" : ""}
//               >
//                 Gallery
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/Courses"
//                 className={location.pathname === "/Courses" ? "active" : ""}
//               >
//                 All Courses
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/Contact"
//                 className={location.pathname === "/Contact" ? "active" : ""}
//               >
//                 Contact
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/Parents"
//                 className={location.pathname === "/ParentSection" ? "active" : ""}
//               >
//                 Parent's
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/about"
//                 className={location.pathname === "/about" ? "active" : ""}
//               >
//                 About
//               </Link>
//             </li>
//             {/* <li>
//               <Link
//                 to="/locate us"
//                 className={location.pathname === "/locateUs" ? "active" : ""}
//               >
//                 Locate Us
//               </Link>
//             </li> */}
//             <li>
//               <Link
//                 to="/Admission"
//                 className={location.pathname === "/Admission" ? "active" : ""}
//               >
//                 Admission
//               </Link>
//             </li>
//           </ul>
//           <div className="start">
//             <Link
//               to="/principal-desk"
//               className={
//                 location.pathname === "/principal-desk" ? "button active" : "button"
//               }
//             >
//               Principal's Desk
//             </Link>
//           </div>

//           <button className="toggle" onClick={() => setClick(!click)}>
//             {click ? <i className="fa fa-times"></i> : <i className="fa fa-bars"></i>}
//           </button>
//         </nav>
//       </header>
//     </>
//   );
// };

// export default Header;




import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Head from "./Head";
import "./header.css";

const Header = () => {
  const [click, setClick] = useState(false);
  const location = useLocation();

  return (
    <>
      <Head />
      <header>
        <nav className="flexSB">
          <ul
            className={click ? "mobile-nav" : "flexSB"}
            onClick={() => setClick(false)}
          >
            <li>
              <Link to="/" className={location.pathname === "/" ? "active" : ""}>
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/Gallery"
                className={location.pathname === "/Gallery" ? "active" : ""}
              >
                Gallery
              </Link>
            </li>
            <li>
              <Link
                to="/Courses"
                className={location.pathname === "/Courses" ? "active" : ""}
              >
                All Courses
              </Link>
            </li>
            <li>
              <Link
                to="/Contact"
                className={location.pathname === "/Contact" ? "active" : ""}
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                to="/Parents"
                className={location.pathname === "/ParentSection" ? "active" : ""}
              >
                Parent's
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={location.pathname === "/about" ? "active" : ""}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/Admission"
                className={location.pathname === "/Admission" ? "active" : ""}
              >
                Admission
              </Link>
            </li>
            <li>
              <Link
                to="/fee-structure"
                className={location.pathname === "/fee-structure" ? "active" : ""}
              >
                Fee Structure
              </Link>
            </li>
          </ul>
          <div className="start">
            <Link
              to="/principal-desk"
              className={
                location.pathname === "/principal-desk" ? "button active" : "button"
              }
            >
              Principal's Desk
            </Link>
          </div>

          <button className="toggle" onClick={() => setClick(!click)}>
            {click ? <i className="fa fa-times"></i> : <i className="fa fa-bars"></i>}
          </button>
        </nav>
      </header>
    </>
  );
};

export default Header;
